import {MaintenanceEvent} from "@/lib/types/maintenance.ts";
import {getDurationDisplay} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/MaintenanceSchedulesTable.utils.ts";

export const getEventDetailsName = (event: MaintenanceEvent): string => {
  return event.schedule?.name ?? "—";
};

export const getEventDetailsDuration = (event: MaintenanceEvent): string => {
  if (!event.schedule?.duration_minutes) return "";
  return `Duration: ${getDurationDisplay(event.schedule.duration_minutes)}`;
};
